import { LoginFunction } from 'components/providers/loginContext';
import { ENDPOINT_WORKFLOW_APPS } from 'constants/constants';
import { getAPI } from 'utils/commonService';

interface WfApiResponse<T> {
  results: T[];
}

export type WorkflowApp = {
  id: number;
  versionNo: number;
  name: string;
  serviceClass: string;
  appKey: string;
  iconUrl: string;
  iconFileName: string;
  createdAt: string | null;
  updatedAt: string | null;
  beginningAt: string;
  endingAt: string | null;
  enableFlg: boolean;
  iconData?: string;
  [key: string]: string | number | boolean | null | undefined;
  executeKey: string;
};

export type WorkflowApps = WfApiResponse<WorkflowApp>;

type WorkflowAppSortKey = keyof WorkflowApp;
type Order = 'asc' | 'desc';

// WFアプリの情報取得
export async function getWorkflowApps(
  itemsPerPage: number,
  page: number,
  loginContext: LoginFunction,
  sort?: WorkflowAppSortKey,
  order?: Order,
): Promise<WorkflowApps> {
  const params = { itemsPerPage, page, sort, order };
  return (await getAPI(
    ENDPOINT_WORKFLOW_APPS,
    loginContext,
    params,
  )) as WorkflowApps;
}
